import { Component, Input, OnInit } from '@angular/core';
import { ModalController, AlertController, ActionSheetController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { JavapiService } from '../../services/javapi.service';
import { MetodosgenService } from '../../services/metodosgen.service';
import { Metodosui } from '../../services/metodosui';
import { FacturaFiscalComponent } from '../facturafiscal/facturafiscal.component';
import { Browser } from '@capacitor/browser';

@Component({
    selector: 'app-facturamenu',
    templateUrl: './facturamenu.component.html',
    styleUrls: ['./facturamenu.component.scss'],
    standalone: false
})
export class FacturamenuComponent implements OnInit {

    @Input() factura: any;
    @Input() viewMode: 'default' | 'minimal' = 'default';
    userData: any;
    items: any[] = [];
    isLoadingItems = false;
    permissions: any = {};

    constructor(
        private modalCtrl: ModalController,
        private alertCtrl: AlertController,
        private actionSheetCtrl: ActionSheetController,
        private javapiService: JavapiService,
        private metodosGenService: MetodosgenService,
        private metodosUi: Metodosui
    ) { }

    ngOnInit() {
        const userJson = localStorage.getItem('user');
        if (userJson) {
            this.userData = JSON.parse(userJson);
            this.permissions = this.metodosGenService.getPermissions();
        }
        if (this.factura && this.factura.id) {
            this.loadItems();
        }
    }

    async loadItems() {
        this.isLoadingItems = true;
        try {
            const payload = this.metodosGenService.setModeloGeneral(
                'genModel', 'factura_empresa_detalles',
                String(this.factura.id), '', '', '', '', '', '', '', '', '', '', '', '', '', ''
            );
            const data: any = await firstValueFrom(this.javapiService.getCommonModel(payload));
            if (Array.isArray(data)) {
                this.items = data.map(i => ({
                    descripcion: i.dt4,
                    cantidad: +i.dt5,
                    precio_unitario: +i.dt6,
                    precio_total: +i.dt7,
                    oc: i.dt8
                }));
            }
        } catch (e) {
            console.error('Error cargando ítems:', e);
        } finally {
            this.isLoadingItems = false;
        }
    }

    get vinculatedOcs(): string[] {
        if (!this.items) return [];
        const ocs = this.items.map(i => i.oc).filter(oc => oc && oc.trim() !== '');
        return [...new Set(ocs)];
    }

    copyToClipboard(text: string) {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text).then(() => {
                this.metodosUi.showToast(`Copiado: ${text}`, 'success');
            }).catch(err => {
                console.error('Error al copiar: ', err);
            });
        } else {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand('copy');
                this.metodosUi.showToast(`Copiado: ${text}`, 'success');
            } catch (err) {
                console.error('Fallback error: ', err);
            }
            document.body.removeChild(textarea);
        }
    }

    close() {
        this.modalCtrl.dismiss();
    }

    // ── Edit ───────────────────────────
    async edit() {
        this.modalCtrl.dismiss({ action: 'edit', factura: this.factura });
    }

    // ── Delete ─────────────────────────
    async delete() {
        this.modalCtrl.dismiss({ action: 'delete', factura: this.factura });
    }

    async viewPdf() {
        const url = this.javapiService.getFileUrl('FAC', this.factura.id, false);
        await Browser.open({ url });
    }

    // ── Fiscal Registration ────────────
    async registerFiscal() {
        if (!this.factura.cotizacionId) {
            this.metodosUi.showToast('Esta factura no tiene una cotización vinculada para el registro fiscal.', 'warning');
            return;
        }

        const res = await this.metodosUi.openModal(FacturaFiscalComponent, { factura: this.factura });

        if (res && res.saved) {
            this.modalCtrl.dismiss({ action: 'fiscal_registered' });
        }
    }
}
